import { callApi } from 'utility/Request/callApi';

import { ApiEndpoint } from 'types/Request/endpoint';

import {
    KiFilterResponse,
    KiFilterResponse_KiStatus,
} from 'proto/Api/Llm/KiFilter';
import { ResponseStatus } from 'proto/Api/ResponseStatus';
import { RequestFilterGroup } from 'proto/Search/KiFilter/RequestFilterGroup';

const getFilters = async (
    Propmt: string,
    PortalUrl: string,
    FilterData: RequestFilterGroup[],
    abortController?: AbortController
): Promise<KiFilterResponse | null> => {
    try {
        const response = await callApi(ApiEndpoint.KiFilter, {
            requestData: {
                searchText: Propmt,
                portalUrl: PortalUrl,
                filterData: FilterData,
            },
            abortController,
        });

        if (abortController?.signal?.aborted) {
            return null;
        }
        if (response.signal?.aborted) {
            return KiFilterResponse.fromPartial({
                status: ResponseStatus.Timeout,
                kiStatus: KiFilterResponse_KiStatus.Timeout,
            });
        }

        return (
            response.parsedBody ??
            KiFilterResponse.fromPartial({
                status: ResponseStatus.Error,
                kiStatus: KiFilterResponse_KiStatus.Error,
            })
        );
    } catch {
        return KiFilterResponse.fromPartial({
            status: ResponseStatus.Error,
            kiStatus: KiFilterResponse_KiStatus.Timeout,
        });
    }
};

export { getFilters as getFilters };
